<ion-segment [value]="selectedIndex" (ionChange)="selectTabByIndex($event.detail.value)">
    <ion-segment-button *ngFor="let tab of tabs; let i = index; trackBy: trackByTab" [value]="i">
        <ion-label>{{ tab.title }}</ion-label>
    </ion-segment-button>
</ion-segment>

<div class="chart-content">
    <ng-content></ng-content>
</div>
